import React from 'react';

import Overlay from 'ui/utils/Overlay';
import alignElement from './utils/alignElement';

export const getEventRect = e => ({left: e.clientX, top: e.clientY, right: e.clientX, bottom: e.clientY});

const defaultMethod = [{from: "tl", to: "tr"}, {from: "bl", to: "br"}, {from: "tr", to: "tl"}, {from: "br", to: "bl"}];
const defaultPadding = [0, 20];

export default function Popup({ alignPosition, alignMethod=defaultMethod, alignPadding=defaultPadding, children, ...props }) {
  const [style, setStyle] = React.useState(null);
  const nodeRef = React.useRef();

  const onClose = props.onClose;

  React.useLayoutEffect(() => {
    setStyle(alignElement(nodeRef.current, alignPosition, alignMethod, alignPadding));
    nodeRef.current.focus();
  }, [alignPosition, alignMethod, alignPadding]);

  const onBlur = React.useCallback(e => {
    if (!e.relatedTarget || !nodeRef.current.contains(e.relatedTarget)) {
      onClose();
    }
  }, [onClose]);

  const onKeyDown = React.useCallback(e => {
    if (e.key === "Esc" || e.key === "Escape") {
      onClose();
    }
  }, [onClose]);

  return (
    <Overlay>
      <div className="ui-Popup" style={{position: "absolute", outline: "none", ...style}} ref={nodeRef} tabIndex="-1" onBlur={onBlur} onKeyDown={onKeyDown}>
        {React.cloneElement(React.Children.only(children), props)}
      </div>
    </Overlay>
  );
}
